<template>
  <div
    id="messageBox"
    class="chat-message-box"
    :style="{ height: heightBox + 'px', paddingTop: ismarqueue ? '20px' : '0' }"
    ref="box"
    @scroll="whereScorll($event)"
  >
    <!-- @scroll="whereScorll($event)" -->
    <!-- <div class="lookHistory" v-if="needShowBtn() && !hasHistoryLoad">
      <span @click="addMoreHistory">点击查看历史记录</span>
    </div> -->
    <!-- <span class="hisLastTime no-more" v-if="hisLastTime && !hasHistoryLoad && !isQueue">
      {{ hisLastTime | datetime }}
    </span> -->
    <div v-if="hasHistoryLoad" class="lookHistory lookHistoryLoad">
      <i class="el-icon-loading" />
      加载中
    </div>
    <slot>
      <div v-if="showNoHistory() && !hasHistoryLoad" class="no-more">
        暂无更多历史消息
      </div>
      <div
        class="messages-layout"
        :style="{
          paddingBottom: padNum + 'px',
          minHeight: isQueue || blackFlag != 0 ? 'auto' : heightBox - 35 + 'px'
        }"
      >
        <template v-for="(item, index) in messages">
          <!-- <div
            href="javascript:void(0)"
            style="display:none;"
            :key="(item.msgId || 'msg-') + index"
          >
            <div class="tip" v-if="item.conversationTip == tip">
              <div class="left_border"></div>
              <div class="content">本次会话的消息</div>
              <div class="right_border"></div>
              <div class="clear"></div>
            </div>
            <chat-message-item
              :message="item"
              @clickImage="clickImage"
              @errorImg="errorImg"
            />
          </div> -->
          <div
            :id="`customer-pc-msg-${index}`"
            :key="(item.msgId || 'msg-') + index + 'pcmessages'"
          >
            <div class="tip" v-if="item.conversationTip == tip">
              <div class="left_border"></div>
              <div class="content">
                本次会话的消息
              </div>
              <div class="right_border"></div>
              <div class="clear"></div>
              <div v-if="isShowNotice">
                <div
                  v-for="(option, i) in NoticeMessage.noticeInfo"
                  :key="i + 3"
                >
                  <div
                    id="notice"
                    v-if="option.noticeType == 2"
                    v-html="Noticetext"
                  ></div>
                </div>
                <div v-for="(option, i) in NoticeMessage.noticeInfo" :key="i">
                  <el-row
                    v-if="option.noticeType == 1 && NoticeMessage"
                    class="nocticeImg"
                    :gutter="20"
                  >
                    <el-col
                      v-for="(imgItem, j) in option.noticeInfoPhoto"
                      :key="j"
                      :span="8"
                    >
                      <img
                        v-if="imgItem.linkType == -1"
                        :src="imgItem.noticeImg"
                        alt="图片通知"
                      />
                      <div class="imgText" v-if="imgItem.linkType == -1">
                        {{ imgItem.noticeTitle }}
                      </div>
                      <a
                        :href="DoMain + imgItem.noticeUrl"
                        target="_blank"
                        v-if="imgItem.linkType == 0"
                      >
                        <img :src="imgItem.noticeImg" alt="图片通知" />
                      </a>
                      <div class="imgText" v-if="imgItem.linkType == 0">
                        {{ imgItem.noticeTitle }}
                      </div>
                      <a
                        :href="imgItem.noticeUrl"
                        v-if="imgItem.linkType == 1"
                        target="_blank"
                      >
                        <img :src="imgItem.noticeImg" alt="图片通知" />
                      </a>
                      <div class="imgText" v-if="imgItem.linkType == 1">
                        {{ imgItem.noticeTitle }}
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>

            <chat-message-item
              :message="item"
              class="hideImgDiv"
              :width="item.width"
              :height="item.height"
              @clickImage="clickImage"
              @errorImg="errorImg"
            />
          </div>
        </template>
      </div>
      <el-image-viewer
        v-if="showViewer"
        :on-close="closeViewer"
        :on-switch="onSwitch"
        :url-list="images"
      />
    </slot>
    <div
      v-show="showBottom"
      @click="scrollBottom"
      :style="{ bottom: isEntering ? '210px' : '180px' }"
      class="moreMsg"
    >
      <span> <i class="el-icon-bottom"></i>回到底部</span>
    </div>
  </div>
</template>

<script>
import chatMessageItem from "./chat-message-item";
import constant from "src/constant";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import historyReconcileScroll from "src/mixins/historyReconcileScroll";
export default {
  name: "chat-message-box",
  components: { chatMessageItem, ElImageViewer },
  mixins: [historyReconcileScroll],
  data() {
    return {
      time: null,
      historyNeedScorll: false,
      index: 0,
      iScroll: true,
      padNum: 0,
      heightBox: 0,
      showBottom: false,
      isHistory: false,
      widthBox: 0,
      tip: constant.MESSAGE_TYPE.MT_CHANNEL_TIP,
      serverAvatar: require("src/assets/imgs/server-avatar.jpg"),
      images: [],
      showViewer: false,
      Noticetext: "",
      Noticeimages: [],
      loadUrl: require("src/assets/imgs/load.gif")
    };
  },
  computed: {
    ...mapGetters(["messages"]),
    ...mapState([
      "isShowLookhistory",
      "messagePageNumber",
      "currCustomer",
      "isBeforeConnect",
      "isShowHistoryBtn",
      "hasHistory",
      "isConversation",
      "isEntering",
      "isSendFlag",
      "hasHistoryLoad",
      "isQueue",
      "height",
      "blackFlag",
      "isShowNotice",
      "NoticeMessage",
      "DoMain",
      "ismarqueue"
    ]),
    imageMap() {
      let map = {};
      this.messageImages.forEach(item => {
        map[item.msgId] = item;
      });
      return map;
    },
    messageImages() {
      return this.messages
        .filter(
          item =>
            item.type === constant.MESSAGE_TYPE.MT_IMAGE ||
            item.type === constant.MESSAGE_TYPE.MT_TEXT_PHOTO ||
            item.type === constant.MESSAGE_TYPE.MT_TEXT_CURRENCY
        )
        .map((item, index) => {
          this.images.push(item.filePath);
          return {
            index,
            msgId: item.msgId,
            title: this.formatTimeStamp(item.chatTime),
            src: item.localPath || item.filePath
          };
        });
    },
    hisLastTime() {
      if (this.messages.length > 0) {
        return this.messages[0].chatTime;
      } else {
        return 0;
      }
    }
  },
  watch: {
    messages(val, old) {
      // console.log(val);
      if (this.preserveHistoryReconcileViewport(val, old)) return;
      if (val.length != old.length) {
        if (this.isHistory) {
          return false;
        }
        if (!this.isSendFlag) {
          this.isScroll();
        } else {
          this.scrollBottom();
          this.showBottom = false;
        }
      }
      // if (this.isHistory) {
      //   return false;
      // }

      // // 自己发的
      // if (
      //   val.length - old.length == 1 &&
      //   val.length > 0 &&
      //   old.length > 0 &&
      //   val[val.length - 1] &&
      //   !val[val.length - 1].sendFlag
      // ) {
      //   let index = old.findIndex(
      //     item => val[val.length - 1].msgId == item.msgId
      //   );
      //   if (index == -1) {
      //     this.scrollBottom();
      //     this.showBottom = false;
      //   }
      // }
      // return val;
    },
    isEntering() {
      if (this.isEntering) {
        this.padNum = 20;
        // this.heightBox = this.heightBox - 25;
      } else {
        this.padNum = 0;
        // this.heightBox = this.heightBox + 25;
      }
    },
    isConversation() {
      if (!this.isConversation) {
        this.heightBox = this.heightBox + 50;
      } else {
        this.heightBox = this.heightBox - 50;
      }
    },
    ismarqueue() {
      // this.heightBox = this.heightBox - 30;
    },
    height(val) {
      if (!this.isConversation) {
        this.heightBox = val - 190;
      } else {
        this.heightBox = val - 240;
      }
    }
  },
  mounted() {
    this.eventBus.$on("scrollMessageBox", this.handleScrollMessageBox);
    if (!this.isConversation) {
      this.heightBox = this.height - 190;
    } else {
      this.heightBox = this.height - 240;
    }
    if (this.ismarqueue) {
      this.heightBox = this.heightBox - 30;
    }
    this.widthBox = document.querySelector("#messageBox").clientWidth;

    const _this = this;
    setInterval(function() {
      if (_this.isShowNotice && _this.Noticetext === "") {
        _this.filleLink();
      }
    }, 1000);
  },
  methods: {
    handleScrollMessageBox() {
      this.$nextTick(() => {
        const messageBox = document.querySelector("#messageBox");
        // 判断滚动条是否在最下面
        messageBox.scrollTop =
          messageBox.scrollHeight - messageBox.offsetHeight;
      });
      window.addEventListener("scroll", this.whereScorll, true);
    },
    // 链接过滤
    filleLink() {
      if (this.NoticeMessage.noticeInfo) {
        this.NoticeMessage.noticeInfo.forEach(element => {
          if (element.noticeType == 2) {
            this.Noticetext = element.noticeContent;
          }
        });
      }
      // this.Noticetext = this.Noticetext.replace(/<a/g, "<a target='_blank'");
      let elem_buff = document.createElement("div");
      elem_buff.innerHTML = this.Noticetext;
      let as = elem_buff.getElementsByTagName("a");
      if (as.length == 0) {
        // console.log(this.Noticetext);
        return this.Noticetext;
      }
      for (let i = 0; i < as.length; i++) {
        let href = as[i].getAttribute("href");
        if (href.indexOf("www") < 0 || href.indexOf("http") < 0) {
          as[i].setAttribute("href", this.DoMain + href);
        }
      }
      this.Noticetext = elem_buff.innerHTML;
    },
    // 关闭查看器
    closeViewer() {
      this.images = [];
      this.showViewer = false;
    },
    onSwitch(index) {
      this.index = index;
      setTimeout(() => {
        let viewImgnow = this.images[index];
        let viewImg = document.querySelector(
          ".el-image-viewer__canvas .el-image-viewer__img"
        );
        // console.log(viewImg, getComputedStyle(viewImg).width);
        if (viewImg) {
          viewImg.src = this.loadUrl;
        }
        var imgLoad = new Image();
        imgLoad.src = viewImgnow;
        imgLoad.onload = () => {
          // console.log(
          //   "加载完成",
          //   viewImgnow
          // );
          setTimeout(() => {
            viewImg.src = viewImgnow;
            this.images[index] = viewImgnow;
          }, 1);
        };
      }, 10);
    },
    errorImg(message) {
      this.$store.commit("setState", {
        messages: this.messages.map(item =>
          item.msgId === message.msgId
            ? (item.serverImage = this.serverAvatar)
            : item.serverImage
        )
      });
    },
    formatMessageDate(message) {
      return moment(_.get(message, "chatTime"), "x").format(
        "YYYY-MM-DD HH:mm:ss"
      );
    },
    isDayFirstMessage(message, index) {
      if (index <= 0) {
        return true;
      } else {
        let prevMessageTime = this.messages[index - 1];
        const prevMessageDate = moment(prevMessageTime.chatTime, "x").get(
          "date"
        );
        const currMsgDate = moment(message.chatTime, "x").get("date");
        return currMsgDate !== prevMessageDate;
      }
    },
    clickImage(message) {
      this.index = _.get(this, `imageMap[${message.msgId}].index`, null);
      this.images.forEach((element, i) => {
        if (i < this.index) {
          this.images.push(this.images[i]);
          delete this.images[i];
        }
      });
      this.images = this.images.filter(function(e) {
        return e;
      });
      this.showViewer = true;
    },
    isScroll() {
      this.$nextTick(() => {
        const messageBox = document.querySelector("#messageBox");
        // messageBox.scrollIntoView();
        window.messageBox = messageBox;
        clearTimeout(this.time);
        this.time = setTimeout(() => {
          if (!this.historyNeedScorll) {
            if (!this.showBottom) {
              messageBox.scrollTop = messageBox.scrollHeight + 210;
              messageBox.scrollIntoView(messageBox.scrollHeight);
            }
          } else {
            this.historyNeedScorll = false;
          }
        }, 100);
      });
    },
    scrollBottom() {
      this.$nextTick(() => {
        const messageBox = document.querySelector("#messageBox");
        window.messageBox = messageBox;
        clearTimeout(this.time);
        this.time = setTimeout(() => {
          if (!this.historyNeedScorll) {
            messageBox.scrollTop = messageBox.scrollHeight + 240;
          } else {
            this.historyNeedScorll = false;
          }
        }, 100);
      });
    },
    needShowBtn() {
      return !!this.hasHistory && this.isConversation;
    },
    showNoHistory() {
      return !this.hasHistory && this.isConversation;
    },
    addMoreHistory() {
      // this.$store.commit("setState", {
      //   isShowHistoryBtn: false,
      //   hasHistory: false
      // });

      this.historyNeedScorll = false;
      // messagePageNumber,
      let { currCustomer } = this;
      // messagePageNumber++;
      // this.$store.commit("setState", {
      //   messagePageNumber
      // });
      return this.$store.dispatch("getMessages", currCustomer);
    },
    async whereScorll(e) {
      if (
        e.srcElement.scrollHeight - e.srcElement.scrollTop - 200 <
        e.srcElement.offsetHeight
      ) {
        this.showBottom = false;
      } else {
        this.showBottom = true;
      }
      if (
        e.srcElement.scrollTop == 0 &&
        !this.showNoHistory() &&
        !this.isQueue &&
        this.iScroll
      ) {
        this.iScroll = false;
        try {
          await this.addMoreHistory();
        } finally {
          this.iScroll = true;
        }
        // clearTimeout(this.time);
        // this.time = setTimeout(() => {

        // }, 1000);
      }

      this.isHistory = false;
      this.$store.commit("setState", {
        isSendFlag: false
      });
    }
  },
  beforeDestroy() {
    clearTimeout(this.time);
    this.eventBus.$off("scrollMessageBox", this.handleScrollMessageBox);
    window.removeEventListener("scroll", this.whereScorll, true);
  }
};
</script>
<style lang="less" scoped>
.el-row {
  padding-top: 10px;
  margin: 0 auto 20px !important;
  width: 380px;
  &:last-child {
    margin-bottom: 0;
  }
  .el-col-8 {
    text-align: center;
  }
  img {
    max-width: 90px;
    border-radius: 5px;
  }
}
.imgText {
  text-align: center;
}
.chat-message-box {
  position: relative;
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 40px;
  min-height: 200px !important;
  .nocticeImg {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 100%;
    }
  }
  /*滚动条样式*/
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 20px;
    background-color: #c1c1c1;
  }
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background-color: #ebebeb;
  }
  .messages-layout {
    padding: 15px 15px 0;
  }
}

.no-more {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  font-size: 12px;
  color: #b4b4b4;
}

.day-first-time {
  color: #b4b4b4;
  margin: 20px 0;
  line-height: 20px;
  font-size: 13px;
  text-align: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    display: block;
    margin: 0 15px;
  }
}

.lookHistory {
  background: #f3f3f3;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1988ef;
  position: sticky;
  background: #f8f8f8;
  z-index: 99;
  top: 0;
  &:hover {
    text-decoration: underline;
  }

  span {
    cursor: pointer;
    padding: 10px 20px;
  }
}

.lookHistoryLoad {
  background: transparent;
  font-size: 16px;
  color: #787878;
  &:hover {
    text-decoration: none;
  }

  i {
    margin: 10px 0;
  }
}

.moreMsg {
  position: fixed;
  bottom: 180px;
  right: 0;
  cursor: pointer;

  span {
    display: inline-block;
    min-width: 95px;
    line-height: 33px;
    background-color: var(--header-bg);
    opacity: 0.7;
    border-radius: 50px 0 0 50px;
    text-align: left;
    font-size: 13px;
    color: #ffffff;
    padding-right: 10px;

    i {
      margin-left: 12px;
    }
  }
}

.tip {
  width: 100%;
  font-size: 12px;
  margin-bottom: 10px;
  margin-top: 15px;
  .left_border {
    width: 35%;
    height: 0px;
    border-top: 1px solid #ccc;
    float: left;
    position: relative;
    top: 5px;
  }
  .content {
    width: 30%;
    float: left;
    text-align: center;
    color: #b4b4b4;
  }
  .right_border {
    float: left;
    width: 35%;
    position: relative;
    top: 5px;
    height: 0px;
    border-top: 1px solid #ccc;
  }
  .clear {
    clear: both;
  }
  #notice {
    padding: 5px;
    border: 1px solid #ccc;
    text-align: center;
    line-height: 20px;
    text-align: left;
    width: 70%;
    margin: 10px auto 0;
    background: rgba(255, 255, 0, 0.2745098);
    border-radius: 5px;
  }
}
</style>
<style>
.el-image-viewer__close {
  color: #fff;
}
.hisLastTime {
  background-color: #dcdfe6fc;
  border-radius: 50px;
  position: fixed;
  top: 68px;
  text-align: center;
  left: 0;
  right: 0;
  width: 100px;
  margin: auto;
}
</style>
